import React from "react";
import { Singleton } from "helper/tools";
import createOrdenStyles from "./createOrden.module.css";
import styles from "./../tooltip.module.css";
import { FaRegCircleXmark, FaPercent } from "react-icons/fa6";

function PaqueteCard({
  item,
  index,
  ordenBlocked,
  loadBonificacion,
  removeProduct,
  updateProduct,
}) {
  const nombre = item.nombre;
  const marca = item.marca?.nombre ?? "";

  const precio = Singleton.getInstance().format(item.precio);
  const maxCantidad = item.maxCantidad;
  const cantidad = item.cantidad;
  const subTotal = Singleton.getInstance().format(item.subTotal);

  const canPulse = item.canPulse ? "pulse-glow" : "";

  return (
    <>
      <tr
        className={`${createOrdenStyles.tablecenter} ${canPulse}`}
        style={{ borderStyle: "hidden" }}
      >
        <th scope="row">{nombre}</th>
        <td>{marca}</td>
        <td
          style={{
            textAlign: "center",
          }}
        >
          {precio}
        </td>
        <td>
          <div
            style={{
              position: "relative",
              width: "100%",
              display: "block",
            }}
          >
            <input
              style={{
                width: "100%",
                textAlign: "center",
              }}
              type="number"
              min="1"
              step="1"
              value={cantidad}
              max={maxCantidad}
              onChange={(e) => {
                //
                updateProduct(index, Number.parseInt(e.currentTarget.value));
              }}
              disabled={ordenBlocked}
            />
          </div>
        </td>

        <td
          style={{
            textAlign: "center",
          }}
        >
          {subTotal}
        </td>
        <td>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <>
              <button
                className={`btn btn-warning ${styles.tooltip}`}
                disabled={ordenBlocked}
                onClick={(event) => {
                  console.log("--->removeProduct");
                  loadBonificacion(item);
                }}
                style={{
                  marginLeft: "0px",
                  marginRight: "5px",
                }}
                type="button"
              >
                <div>
                  <span className={`${styles.tooltiptext}`}>Bonificación</span>
                  <FaPercent />
                </div>
              </button>
              <button
                className={`btn btn-danger ${styles.tooltip}`}
                onClick={(event) => {
                  console.log("--->removeProduct");

                  removeProduct(index);
                }}
                style={{ marginLeft: "0px" }}
                type="button"
                disabled={ordenBlocked}
              >
                <div>
                  <span className={`${styles.tooltiptext}`}>Eliminar</span>
                  <FaRegCircleXmark />
                </div>
              </button>
            </>
          </div>
        </td>
      </tr>

      {item.productos.map((item, index) => {
        const nombre = item.producto?.nombre;
        const cantidad = item.cantidad;
        const precio =
          item.precioHistorial != null
            ? item.precioHistorial?.precio
            : item.precio;
        const precioVenta = Singleton.getInstance().format(precio);

        const total = precio * cantidad;
        const totalPrecio = Singleton.getInstance().format(total);

        return (
          <tr className={`${createOrdenStyles.tablecenter} ${canPulse}`}>
            <td style={{ paddingLeft: "15px" }}>
              {index + 1} - {nombre}
            </td>
            <td>{marca}</td>
            <td>{precioVenta}</td>
            <td style={{ textAlign: "center" }}>{cantidad}</td>
            <td>{totalPrecio}</td>
            <td></td>
          </tr>
        );
      })}
      {item.bonificaciones &&
        item.bonificaciones.map((e, index) => {
          return (
            <tr key={index}>
              <td
                colSpan="5"
                style={{
                  textAlign: "right",
                  fontWeight: "bold",
                }}
              >
                Bonificación
              </td>
              <td
                style={{
                  textAlign: "right",
                  fontWeight: "bold",
                }}
              >
                {e.promocion.codigo}
              </td>
              <td colSpan={2}></td>
            </tr>
          );
        })}

      <tr
        className=""
        style={{ borderStyle: "solid", borderWidth: "1px" }}
      ></tr>
    </>
  );
}

export default PaqueteCard;
